<template>
  <div class>
    <header class="header flex-box">
      <div @click="back" class="flex1 flex-box flex-v-c">
        <i class="iconfont icon-houtui"></i> 返回
      </div>
      <div class="headerTitle flex1 flex-box flex-hv-c">奖励进度详情</div>
      <div class="flex1"></div>
    </header>
    <div class="detailContent" v-cloak>
      <ul>
        <!--<h3 style="text-align: center;font-size: 0.3rem;font-weight: bold;">亲友圈详情</h3>-->
        <li class="flex-box flex-v-c bb">
          <div>代理ID：</div>
          <div class>{{data.memberId}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>亲友圈ID：</div>
          <div>{{data.clubIds}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>游戏ID：</div>
          <div class>{{data.gameId}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>游戏昵称：</div>
          <div class>{{data.nickname}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>奖励场次时间：</div>
          <div v-if="data.awardStartTime">{{data.awardStartTime}} - {{ data.awardEndTime}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>审核场次时间：</div>
          <div v-if="data.reviewStartTime">{{data.reviewStartTime}} - {{ data.reviewEndTime}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>场次应发时间：</div>
          <div v-if="data.sendAwardTime">{{data.sendAwardTime}}</div>
        </li>
        <li class="flex-box flex-v-c bb">
          <div>当前奖励场次：</div>
          <div>{{data.awardPlayCount}}</div>
        </li>

        <li class="bb">
          <div class="flex-box flex-v-c pdb">
            <div>第一阶段：</div>
            <div class="tip">{{data.stageAward.first}}</div>
          </div>
          <div class="flex-box flex-v-c pdb">
            <div>第二阶段：</div>
            <div class="tip">{{data.stageAward.second}}</div>
          </div>
          <div class="flex-box flex-v-c pdb">
            <div>第三阶段：</div>
            <div class="tip">{{data.stageAward.third}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<!--javascript-->
<script>
export default {
  props: ['id'],
  data: function () {
    return {
      data: {}
    }
  },
  methods: {
    getData() {
      this.$http.get('/award/detail', { params: { id: this.id } }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
        } else {
          this.$toast(res.message)
        }
      })
    }/*,
      close(){
          this.$emit('ctrDetails',false)
      }*/,
    back() {
      this.$emit('ctrDetails', false)
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
  }

}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.pdb {
  padding-bottom: 10px;
}

.detail {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background: #fff;
  width: 100%;
  height: 100%;
}

.detailContent {
  -webkit-overflow-scrolling: touch;
  overflow: auto;
  height: calc(100vh - 1rem);
  padding: 10px;
}
ul li {
  padding: 0.2rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/awardProgress/detail.vue